import { PageTitle } from "@components/common/page-title";
import { ContactSupport } from "@components/ulm/contact-support";
import { UlmButton } from "@components/ulm/ulm-button";
import { UlmContainer } from "@components/ulm/ulm-container";
import { useAppNavigation } from "@hooks/use-app-navigation";
import { Box } from "@mui-wrapper";
import { Text } from "@flat-ui";

/**
 * Renders a page indicating that trials are temporarily unavailable.
 */
export function TrialUnavailable(): JSX.Element {
  const { navigateToLogin } = useAppNavigation();

  return (
    <UlmContainer>
      <PageTitle>Trials are temporarily unavailable</PageTitle>
      <Text
        variant="bodyM"
        sx={{
          marginY: "24px",
        }}
      >
        Please check back soon. If you already have an account, you can log in.
      </Text>
      <UlmButton
        onClick={navigateToLogin}
        sx={{
          marginTop: "20px",
        }}
      >
        Log in
      </UlmButton>
      <Box
        component="div"
        sx={{
          marginBottom: "10px",
          fontSize: "14px",
          flex: 1,
          alignContent: "end",
          marginTop: "20px",
        }}
      >
        Questions? Contact <ContactSupport />
      </Box>
    </UlmContainer>
  );
}
